import api, { getMsal, getGoogleCredential } from '../api';
import { loadAvatars } from '../components/UserAvatar';

// Copies the signed-in person's sign-in photo to Harbor (routes/avatars.py):
// their Microsoft 365 photo, read here from Microsoft Graph, or their Google
// picture, which the server fetches. A picture they uploaded in Profile is
// never replaced. At most once a day per browser unless forced (after they
// remove their upload).

const KEY = 'harborAvatarSyncedAt';
const DAY = 24 * 60 * 60 * 1000;

export async function syncMyAvatar({ force = false } = {}) {
  if (process.env.REACT_APP_MOCK_MODE === 'true') return;
  if (localStorage.getItem('impersonateUserId')) return;
  try {
    if (!force && Date.now() - Number(localStorage.getItem(KEY) || 0) < DAY) return;
  } catch {}

  let saved = false;
  const msal = await getMsal();
  const account = msal && (msal.getActiveAccount() || msal.getAllAccounts()[0]);
  try {
    if (account) {
      const { accessToken } = await msal.acquireTokenSilent({ scopes: ['User.Read'], account });
      const res = await fetch('https://graph.microsoft.com/v1.0/me/photos/120x120/$value', {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (res.ok) {   // 404: no photo in Microsoft 365
        const body = new FormData();
        body.append('source', 'm365');
        body.append('file', await res.blob(), 'm365.jpg');
        saved = (await api.put('/api/me/avatar', body)).data?.saved;
      }
    } else if (getGoogleCredential()) {
      saved = (await api.post('/api/me/avatar/sync-google')).data?.saved;
    }
    try { localStorage.setItem(KEY, String(Date.now())); } catch {}
  } catch {
    // No permission to read the photo, or Microsoft/Google unreachable:
    // they keep what they have (or their initials) and it is tried again
    // next visit.
  }
  if (saved || force) loadAvatars(true);
}
